import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/ebook/ebook-5step.png";
import Img1 from "../../images/ebook/10-mob-app.png";
import Img2 from "../../images/ebook/successful-entrepreneur.png";
import Img3 from "../../images/ebook/cracking-code.png";
import Img4 from "../../images/ebook/million-dollar.png";
import Down from "../../images/ebook/download.png";



function Ebook(props) {
    const handleDownload = (pdfUrl) => {
        window.open(pdfUrl);
    };
    return (
        <div className="ebook-form p-100" >
            <Container>
                <Row className="h-100">
                    <Col xs={12} md={6} lg={12} xl={12} xxl={12} className="my-auto">
                        <div className="ebook-head">
                            <h2>E-Books</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-5-step-guide-mobile-app-development.pdf")}>
                            <h4>Mobile App<br/> Development</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() =>handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-10-mobile-app-trends-2023.pdf")}>
                            <h4>10 Mobile Apps <br/> Development Trends</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-How-to-become-a-Successful-App-Entrepreneur.pdf")}>
                            <h4>How To Become a Successful<br/> App Entrepreneur</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img2}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-Cracking-the-Code-Consumer.pdf")}>
                            <h4>Consumer Preferences<br/> and App Development</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img3}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/million-dollar-app-checklist.pdf")}>
                            <h4>Million Dollar<br/> App Checklist</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img4}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col xs={12} md={6} lg={12} xl={12} xxl={12} className="my-auto">
                        <div className="ebook-head">
                            <h2>White-Paper</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-5-step-guide-mobile-app-development.pdf")}>
                            <h4>Mobile App<br/> Development</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() =>handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-10-mobile-app-trends-2023.pdf")}>
                            <h4>10 Mobile Apps <br/> Development Trends</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-How-to-become-a-Successful-App-Entrepreneur.pdf")}>
                            <h4>How To Become a Successful<br/> App Entrepreneur</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img2}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-Cracking-the-Code-Consumer.pdf")}>
                            <h4>Consumer Preferences<br/> and App Development</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img3}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/million-dollar-app-checklist.pdf")}>
                            <h4>Million Dollar<br/> App Checklist</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img4}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
                        <div className="ebook-head">
                            <h2>Guides</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-5-step-guide-mobile-app-development.pdf")}>
                            <h4>Mobile App<br/> Development</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() =>handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-10-mobile-app-trends-2023.pdf")}>
                            <h4>10 Mobile Apps <br/> Development Trends</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-How-to-become-a-Successful-App-Entrepreneur.pdf")}>
                            <h4>How To Become a Successful<br/> App Entrepreneur</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img2}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/eBook-Cracking-the-Code-Consumer.pdf")}>
                            <h4>Consumer Preferences<br/> and App Development</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img3}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
                        <div className="ebook-all" onClick={() => handleDownload("https://d3r5yd0374231.cloudfront.net/images-tek/assets/pdf/million-dollar-app-checklist.pdf")}>
                            <h4>Million Dollar<br/> App Checklist</h4>
                            <LazyLoadImage
                                src={Down}
                                effect="blur" alt="Image" className="img-fluid download"
                            />
                            <div className="ebook-fig">
                                <LazyLoadImage
                                    src={Img4}
                                    effect="blur" alt="Image" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Ebook;